(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bottom-announcement-bar"]) return;
  try {
    
  fetch('https://dropshipadministrator2717.com/YSW/coupon_scheduler/current_promo.js')
    .then((response) => response.text())
    .then((scriptText) => {
      // Execute external JS content
      eval(scriptText);

      if (typeof ysw_current_promo !== 'undefined' && ysw_current_promo) {
        // Dollar Amount
        const amountEl = document.getElementById('hc_dollar_amount');

        if (amountEl && ysw_current_promo.dollar_amount) {
          const formattedAmount = parseFloat(ysw_current_promo.dollar_amount).toFixed(0);

          amountEl.textContent = '$' + formattedAmount;
        }

        // Coupon Code
        const couponEl = document.getElementById('hc_coupon_code');
        if (couponEl && ysw_current_promo.coupon_code) {
          couponEl.textContent = ysw_current_promo.coupon_code;
        }

        // End Date (MM/DD/YYYY without timezone conversion)
        const dateEl = document.getElementById('hc_end_date');

        if (dateEl && ysw_current_promo.end_date) {
          const rawDate = ysw_current_promo.end_date; // 2026-05-21
          const [year, month, day] = rawDate.split('-');

          const formattedDate = month + '/' + day + '/' + year;

          dateEl.textContent = formattedDate;
        }
      }
    })
    .catch((error) => {
      console.error('Error loading promo data:', error);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
